module.exports = __webpack_public_path__ + "media/images/duel/confetti-left-bd897f9bbefc6fc6c817c356792feba9.svg";